import React, { useEffect, useMemo, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";
import ChangePasswordForm from "../../../components/Profile/Password/ChangePasswordForm";
import UpdateInfoForm from "../../../components/Profile/Info/UpdateInfoForm";
import DeleteAccount from "../../../components/Profile/DeleteAccount/DeleteAccount";
import AddViewer from "../../../components/DashBoard/addViewer";
import styles from "./ProfilePage.module.css";

export default function ProfileSettingsPage() {
  const [isProvider, setIsProvider] = useState(false);

  useEffect(() => {
    const idToken = localStorage.getItem("idToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!idToken && !accessToken) {
      window.location.href = "/login";
      return;
    }
    if (!idToken) return;
    try {
      const decoded: any = jwtDecode(idToken);
      const groups = decoded["cognito:groups"] || [];
      setIsProvider(groups.includes("provider") || groups.includes("Provider"));
    } catch {
      /* ignore */
    }
  }, []);

  const dashboardHref = useMemo(() => (isProvider ? "/dashboard" : "/patient-dashboard"), [isProvider]);

  const signOut = () => {
    localStorage.removeItem("idToken");
    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  };

  return (
      <div className={styles.page}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h1 className={styles.title}>Settings</h1>
            <p className={styles.subtitle}>
              Security, personal details, and who else can see your sessions.
            </p>
          </div>

          <div className={styles.actions}>
            <Link to="/profile" className="ui-btn ui-btn--ghost">
              Back to profile
            </Link>
            <Link to={dashboardHref} className="ui-btn ui-btn--secondary">
              Dashboard
            </Link>
            <button
              type="button"
              className="ui-btn ui-btn--danger"
              onClick={signOut}
            >
              Sign out
            </button>
          </div>
        </div>

        <section className={styles.stack} aria-label="Account settings">
          <h2 className={styles.groupTitle}>Account</h2>
          <ChangePasswordForm />
          <UpdateInfoForm />
          <DeleteAccount />
        </section>

        {!isProvider ? (
          <section className={styles.stack} aria-label="Authorized users">
            <h2 className={styles.groupTitle}>Authorized users</h2>
            <AddViewer />
          </section>
        ) : null}
      </div>
  );
}

